import { render, staticRenderFns } from "./LinkHandler.vue?vue&type=template&id=1c0d754a&scoped=true"
import script from "./LinkHandler.vue?vue&type=script&lang=js"
export * from "./LinkHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d754a",
  null
  
)

export default component.exports